import React, { useEffect, useState, useRef } from 'react';
import { graphql } from 'gatsby';

//@ts-ignore
import * as styles from './global-offices.module.css';
//@ts-ignore
import ArrowLgButton from '../Global/ArrowLgButton';
import {
    KontentStringValue,
    KontentMedia,
    KontentRadioMultiChoice,
} from '../../../types/KontentProps';
//@ts-ignore
import { getMediaData, getMultiChoice } from '../Global/DataUtils';

type Office = {
    id?: number;
    elements: {
        office_location_image: KontentMedia;
        city: KontentStringValue;
        contact_email: KontentStringValue;
        country: KontentStringValue;
        display_name: KontentStringValue;
        latitude: KontentStringValue;
        longitude: KontentStringValue;
        postal_code: KontentStringValue;
        site_url: KontentStringValue;
        new_same_window?: KontentRadioMultiChoice<'new' | undefined>;
        state_or_territory: KontentStringValue;
        street_1: KontentStringValue;
        street_2: KontentStringValue;
        toll_free_phone: KontentStringValue;
        local_phone: KontentStringValue;
    };
};

type galleryWidth = number;
type left = number;
type width = number;
type cardWidth = number;
type showWidth = number;

interface Props {
    id?: string;
    offices: {
        value: Office[];
    };
}

const GlobalOffices: React.FC<Props> = ({ offices, ...props }) => {
    const [currentOffice, setCurrentOffice] = useState(0);
    const [currentPosition, setCurrentPosition] = useState(0);
    const [width, setWidth] = useState(0);
    const [left, setLeft] = useState(0);
    const galleryWrap = useRef<any>(null);
    const cardWidth = width > 360 ? 300 : 260;
    const galleryWidth = offices.value.length * cardWidth;
    const showWidth = width > 360 ? Math.floor((width - 50) / cardWidth) : 1;
    const dotsToShow =
        width > 360
            ? Math.ceil(galleryWidth / cardWidth / showWidth)
            : offices.value.length;
    const [lat, setLat] = useState(offices.value[0].elements.latitude.value);
    const [long, setLong] = useState(offices.value[0].elements.longitude.value);
    const [zoom, setZoom] = useState(3);
    const cloneOffices = [...offices.value];
    const [filteredOffices, setFilteredOffices] = useState(cloneOffices);

    let clickNext = setGalleryPosition(
        galleryWidth,
        width,
        left,
        showWidth,
        cardWidth
    );
    let newGalleryWidth = setNewGalleryWidth(galleryWidth, width, cardWidth);

    const handleClickNext = () => {
        setCurrentOffice(currentOffice + 1);
        setCurrentPosition(currentPosition + 1);
        setLeft(left - cardWidth * showWidth);
    };

    const handleClickPrev = () => {
        setCurrentOffice(currentOffice - 1);
        setCurrentPosition(currentPosition - 1);
        setLeft(left + cardWidth * showWidth);
    };

    const handleChangeCountry = (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const countryClicked = event.currentTarget.value || 'all';

        let officeSelected = cloneOffices.filter((cloneOffice) => {
            return cloneOffice.elements.country.value === countryClicked;
        });

        if (countryClicked === 'all') {
            setLat('36.22042');
            setLong('-31.43312');
            if (galleryWrap.current.getBoundingClientRect().width > 1605) {
                setZoom(3);
            }
            if (galleryWrap.current.getBoundingClientRect().width < 1604) {
                setZoom(2);
            }
            if (galleryWrap.current.getBoundingClientRect().width < 500) {
                setZoom(1);
            }
            setFilteredOffices(cloneOffices);
        } else {
            setLat(officeSelected[0].elements.latitude.value);
            setLong(officeSelected[0].elements.longitude.value);
            if (
                officeSelected[0].elements.latitude.value === '51.5100874125232'
            ) {
                if (galleryWrap.current.getBoundingClientRect().width > 1605) {
                    setZoom(6);
                }
                if (galleryWrap.current.getBoundingClientRect().width < 1604) {
                    setZoom(5);
                }
                if (galleryWrap.current.getBoundingClientRect().width < 500) {
                    setZoom(4);
                }
                if (galleryWrap.current.getBoundingClientRect().width < 285) {
                    setZoom(3);
                }
            } else if (
                officeSelected[0].elements.latitude.value ===
                '-37.83542103905178'
            ) {
                if (galleryWrap.current.getBoundingClientRect().width > 1605) {
                    setZoom(4);
                }
                if (galleryWrap.current.getBoundingClientRect().width < 1604) {
                    setZoom(4);
                }
                if (galleryWrap.current.getBoundingClientRect().width < 1025) {
                    setZoom(3);
                }
                if (galleryWrap.current.getBoundingClientRect().width < 400) {
                    setZoom(2);
                }
            } else if (
                officeSelected[0].elements.latitude.value ===
                '51.21820166211626'
            ) {
                setZoom(7);
            } else if (
                officeSelected[0].elements.latitude.value ===
                '31.173879930892518'
            ) {
                setZoom(5);
            } else if (
                officeSelected[0].elements.latitude.value ===
                '47.505527205631175'
            ) {
                setZoom(7);
            } else if (
                officeSelected[0].elements.latitude.value ===
                '3.046970011760462'
            ) {
                setZoom(9);
            } else if (
                officeSelected[0].elements.latitude.value ===
                '29.37185877283794'
            ) {
                setZoom(7);
            } else if (
                officeSelected[0].elements.latitude.value ===
                '1.2912831212979772'
            ) {
                setZoom(10);
            } else {
                setZoom(9);
            }
            // setZoom(5);
            let indexOfficeSelected = filteredOffices.indexOf(
                officeSelected[0]
            );
            setFilteredOffices(officeSelected);
            setCurrentOffice(0);
            setCurrentPosition(0);
            setLeft(0);
        }
    };

    const renderPrevButton = () => (
        <ArrowLgButton
            strokeColor="#f06623"
            direction="left"
            handleClick={handleClickPrev}
            className={styles.prevArrowButton}
        />
    );

    const renderNextButton = () => (
        <ArrowLgButton
            strokeColor="#f06623"
            direction="right"
            handleClick={handleClickNext}
            className={styles.nextArrowButton}
        />
    );

    const renderDots = (dotsToShow: number, currentPosition: number) => {
        let dots = [];

        for (let i = 0; i < dotsToShow; i++) {
            dots.push(
                <span
                    key={i}
                    style={currentPosition == i ? { background: '#ccc' } : {}}
                ></span>
            );
        }

        if (dotsToShow != 1 && filteredOffices.length > 1) {
            return dots;
        }
    };

    const renderOfficeCard = (officeCard: Office, cardIdx: number) => {
        const officeHref = officeCard.elements.site_url.value.includes('://')
            ? officeCard.elements.site_url.value
            : 'https://' + officeCard.elements.site_url.value;
        const officeWindowTarget =
            getMultiChoice(officeCard.elements.new_same_window) === 'new'
                ? '_new'
                : '_self';
        return (
            <div className={styles.officeCard} key={cardIdx}>
                <img
                    src={
                        getMediaData(officeCard.elements.office_location_image)
                            ?.url
                    }
                />
                <h5>{officeCard.elements.display_name.value}</h5>
                {!!officeCard.elements.street_1.value && (
                    <p>{officeCard.elements.street_1.value}</p>
                )}
                {!!officeCard.elements.street_2.value && (
                    <p>{officeCard.elements.street_2.value}</p>
                )}
                {(!!officeCard.elements.city.value ||
                    !!officeCard.elements.state_or_territory.value ||
                    !!officeCard.elements.postal_code.value ||
                    !!officeCard.elements.country.value) && (
                    <p>
                        {!!officeCard.elements.city.value &&
                            `${officeCard.elements.city.value}, `}
                        {!!officeCard.elements.state_or_territory.value &&
                            `${officeCard.elements.state_or_territory.value}, `}
                        {!!officeCard.elements.postal_code.value &&
                            `${officeCard.elements.postal_code.value}, `}
                        {!!officeCard.elements.country.value &&
                            `${officeCard.elements.country.value}, `}
                    </p>
                )}
                {!!officeCard.elements.local_phone.value && (
                    <p>
                        Tel:{' '}
                        <a
                            href={`tel:${officeCard.elements.local_phone.value}`}
                        >
                            {officeCard.elements.local_phone.value}
                        </a>
                    </p>
                )}
                {!!officeCard.elements.toll_free_phone.value && (
                    <p>
                        Tel:{' '}
                        <a
                            href={
                                'tel:${officeCard.elements.toll_free_phone.value}'
                            }
                        >
                            {officeCard.elements.toll_free_phone.value}
                        </a>
                    </p>
                )}
                {!!officeCard.elements.contact_email.value && (
                    <p>
                        <a
                            href={`mailto:${officeCard.elements.contact_email.value}`}
                        >
                            {officeCard.elements.contact_email.value}
                        </a>
                    </p>
                )}
                {!!officeCard.elements.site_url.value && (
                    <p className={styles.siteUrl}>
                        <a href={officeHref} target={officeWindowTarget}>
                            {officeCard.elements.site_url.value}
                        </a>
                    </p>
                )}
            </div>
        );
    };

    useEffect(() => {
        if (galleryWrap.current.getBoundingClientRect().width > 1275) {
            setZoom(3);
        }
        if (galleryWrap.current.getBoundingClientRect().width < 1270) {
            setZoom(2);
        }
        if (galleryWrap.current.getBoundingClientRect().width < 500) {
            setZoom(1);
        }
        const resizeListener = () => {
            setWidth(galleryWrap.current.getBoundingClientRect().width);
            setCurrentOffice(0);
            setCurrentPosition(0);
            setLeft(0);
        };

        resizeListener();
        window.addEventListener('resize', resizeListener);

        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, []);

    return (
        <>
            <div className={styles.wrapper}>
                <div className={styles.countrySelector}>
                    <h4>Global Offices</h4>
                    <select
                        name="countries"
                        id="countries"
                        onChange={handleChangeCountry}
                    >
                        <option key="0" value="all">
                            All
                        </option>
                        {offices.value.map(
                            (office, index) =>
                                !!office.elements.country.value && (
                                    <option
                                        key={'option' + index}
                                        value={office.elements.country.value}
                                    >
                                        {office.elements.country.value}
                                    </option>
                                )
                        )}
                    </select>
                </div>
                <div id="map">
                    <div className={styles.mapContainer}>
                        {/* TODO: will need to change when get to production */}
                        <iframe
                            src={`https://www.google.com/maps/d/embed?mid=1Sd5AqqcQI_0vW4z9DPy10QjZSba08KKT&hl=en&ll=${lat}%2C${long}&z=${zoom}`}
                            className={styles.mapFrame}
                        ></iframe>
                        {/* <iframe
                            src={`https://www.google.com/maps/d/embed?mid=1B0Pd-ZvsqBWYmGbmImCGuGz2QIFXoGLu&hl=en&ll=${lat}%2C${long}&z=${zoom}`}
                            className={styles.mapFrame}
                        ></iframe> */}
                    </div>
                </div>
            </div>
            <div
                ref={galleryWrap}
                id={styles.galleryWrapper}
                className={styles.wrapper}
            >
                <div
                    id={styles.gallery}
                    className={styles.gallery}
                    style={newGalleryWidth}
                >
                    {currentOffice > 0 && filteredOffices.length > 1
                        ? renderPrevButton()
                        : null}

                    <div style={clickNext}>
                        {filteredOffices?.map((Office, cardIdx) => {
                            return renderOfficeCard(Office, cardIdx);
                        })}
                    </div>

                    {galleryWidth + 50 > width &&
                    currentPosition + 1 < dotsToShow &&
                    filteredOffices.length > 1
                        ? renderNextButton()
                        : null}
                </div>

                <div className={styles.dots}>
                    {renderDots(dotsToShow, currentPosition)}
                </div>
            </div>
        </>
    );
};

export default GlobalOffices;

function setGalleryPosition(
    galleryWidth: galleryWidth,
    width: width,
    marginLeft: left,
    showWidth: showWidth,
    cardWidth: cardWidth
) {
    let newWidth;

    if (galleryWidth < width) {
        if (width / showWidth > cardWidth) {
            newWidth = galleryWidth + cardWidth;
        } else {
            newWidth = width;
        }
    } else {
        newWidth = galleryWidth;
    }
    const galleryPosition: React.CSSProperties = {
        width: newWidth,
        marginLeft: marginLeft,
        transition: 'margin .5s ease-in-out',
    };

    return galleryPosition;
}

function setNewGalleryWidth(
    galleryWidth: galleryWidth,
    width: width,
    cardWidth: cardWidth
) {
    let showWidth = 1;
    let newGalleryWidth = showWidth * cardWidth;

    if (width > 320) {
        showWidth = Math.floor((width - 50) / cardWidth);
        newGalleryWidth = showWidth * cardWidth;
    }

    const galleryInsideWidth: React.CSSProperties = {
        width: newGalleryWidth,
    };

    return galleryInsideWidth;
}

export const fragmentGlobalOffices = graphql`
    fragment GlobalOffices on kontent_item_component___global_maps_and_cards {
        elements {
            offices {
                value {
                    ... on kontent_item_content_item___office_location {
                        id
                        elements {
                            city {
                                value
                            }
                            contact_email {
                                value
                            }
                            country {
                                value
                            }
                            display_name {
                                value
                            }
                            latitude {
                                value
                            }
                            local_phone {
                                value
                            }
                            longitude {
                                value
                            }
                            postal_code {
                                value
                            }
                            site_url {
                                value
                            }
                            new_same_window {
                                value {
                                    codename
                                }
                            }
                            state_or_territory {
                                value
                            }
                            street_1 {
                                value
                            }
                            street_2 {
                                value
                            }
                            toll_free_phone {
                                value
                            }
                            office_location_image {
                                ...kontentImage
                            }
                        }
                    }
                }
            }
        }
    }
`;
